<template>
    <Card>
        <FetchTable :handle="tableHandle" :url="table.url" :columns="table.columns" v-model:orders="table.orders">
            <template #td-name="{row}">
                {{ row.product.name }}
            </template>
            <template #td-balance="{row}">
                {{ Amount.factory(row.balance_with_reserve).toMeasurementString(row.product.measurement) }}
            </template>
            <template #td-reserve="{row}">
                {{ Amount.factory(row.reserve).toMeasurementString(row.product.measurement) }}
            </template>
            <template #td-waiting="{row}">
                {{ Amount.factory(row.waiting).toMeasurementString(row.product.measurement) }}
            </template>
            <template #td-available="{row}">
                {{ Amount.factory(row.balance).toMeasurementString(row.product.measurement) }}
            </template>
            <template #td-updated_at="{row}">
                <Button color="teal" @click="$refs.movingModal.show(row.product_uuid)">
                    {{ DateFormatter.formatDateTime(row.updated_at) }}
                </Button>
            </template>
        </FetchTable>
    </Card>
    <MovingModal ref="movingModal" :warehouse="warehouse"/>
</template>
<script>
import FetchTable from '../../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../../components/new/table/tableHandle';
import Card from '../../../../../components/new/CardComponent.vue';
import Amount from '../../../../../services/Amount.ts';
import MovingModal from '../modals/MovingModal.vue';
import Button from '../../../../../components/new/button/AlphaButton.vue';
import DateFormatter from '../../../../../services/DateFormatter';
export default {
    name: 'AvailableCard',
    components: {
        FetchTable, Card, MovingModal, Button
    },
    props: {
        warehouse: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            Amount: Amount,
            table: {
                url: '/management/warehouses/products/availability',
                orders: [],
                columns: [
                    {key: 'name', name: this.$t('table.titles.product'), width: 'auto', type: 'string', order: false},
                    {key: 'balance', name: this.$t('table.titles.balance'), width: '200px', type: 'number', order: false},
                    {key: 'reserve', name: this.$t('table.titles.reserve'), width: '200px', type: 'number', order: false},
                    {key: 'available', name: this.$t('table.titles.available'), width: '200px', type: 'number', order: false},
                    {key: 'waiting', name: this.$t('table.titles.waiting'), width: '200px', type: 'number', order: false},
                    {key: 'updated_at', name: this.$t('table.titles.last_move_updated_at'), width: '300px', type: 'number', order: false},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows({warehouse_uuids: [this.warehouse.uuid]})
    }
}
</script>
